import React, { useEffect, useState, lazy, Suspense } from "react";

const renderLoader = () => <p>Loading</p>;

const AlertModal = ({ onClose, onAllow, imageSrc, title, description }) => {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const handleAllow = () => {
        onClose();
        onAllow();
    };

    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
      
      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  
    const handleClickOutside = (event) => {
      if (event.target.className === 'modal') {
        onClose();
      }
    };

      const getImageSrc = () => {
        return windowWidth < 500 ? imageSrc.imageSmall : imageSrc.imageLarge;
      };
  
    return (
      <div className="modal" onClick={handleClickOutside}>
        <div className="modal-content" style={{ width: windowWidth < 730 ? '90%' : '60%', borderRadius: '20px' }} >
            <span className="close" onClick={onClose}>&times;</span>
            <div className="image-mask" style={{ borderRadius: '20px 20px 0px 0px' }}>
                <Suspense fallback={renderLoader()}>
                <img 
                    src={getImageSrc()} 
                    alt={title}
                    className='modal-image' 
                />
                </Suspense>
            </div>
            <div className="modal-body">
              <h4>{title}</h4>
              <div className="modal-description">
                  <p dangerouslySetInnerHTML={{ __html: description }}></p>
              </div>
              <div className="modal-footer">  
                  <button type="button" onClick={handleAllow} className="btn btn-primary appbtn px-4 py-2 mb-3">Dar Permiso</button>
              </div>
            </div>
        </div>
      </div>
    );
  };

  export default AlertModal;